import { Dropdown } from 'primereact/dropdown';

export function CategorySwitcher({ categories, currentCategory, onCategoryChange }) {
  const categoryOptions = categories.map(category => ({
    label: category.title,
    value: category.id
  }));

  return (
    <Dropdown
      value={currentCategory}
      options={categoryOptions}
      onChange={(e) => onCategoryChange(e.value)}
      placeholder="Select category"
      className="w-[200px]"
    />
  );
}
